import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html'
})

export class ErrorMessageComponent {
  @Input() appFormControl: FormControl;
  @Input() controlSchema: any;
  constructor() { }

  get control(): FormControl { return this.appFormControl; }

  get viewErrors(): boolean {
    try {
      return this.control?.touched && this.control?.invalid && this.controlSchema?.readOnly !== true;
    } catch (error) { return false; }
  }

}
